import { SamplesBrand } from 'constants/brands';
import {
    UntranslatedPlanNames,
    BundleCatalog,
    StudioPlanCodes,
} from '@landr/pricing';
import { Interval } from '@landr/pricing/lib/src/types/generated';
import { t } from '@lingui/macro';
import getPlanPrices from 'helpers/getPlanPrices/getPlanPrices';
import { GetDiscountedPlan } from 'hooks/useGetDiscountedPlan/useGetDiscountedPlan';

const useStudioPlan = ({
    frequency,
    hasSamplesPlan,
    studioCatalog,
    getDiscountedPlan,
    planCode,
}: {
    frequency: Interval;
    hasSamplesPlan: boolean;
    studioCatalog: BundleCatalog | undefined;
    getDiscountedPlan: GetDiscountedPlan;
    planCode: string;
}) => {
    const title =
        planCode === StudioPlanCodes.StudioEssentials
            ? UntranslatedPlanNames.LandrStudioEssentials
            : UntranslatedPlanNames.LandrStudioStandard;

    const info = hasSamplesPlan
        ? t`This new plan will be added to your current ${SamplesBrand} plan. You will get the credits that come with this plan immediately. You can manage your plans from your Account settings later.`
        : undefined;

    const planByFrequency = studioCatalog?.plans?.find(
        (plan) => plan?.frequency === frequency && plan.code === planCode,
    );

    const discountedPlan = getDiscountedPlan({
        planCode: planByFrequency?.code,
        frequency,
    });

    const subscriptionPrice = planByFrequency?.subscriptionPrice ?? 0;
    const monthlyEquivalentPrice = planByFrequency?.monthlyEquivalentPrice ?? 0;

    const { salePrice, monthlyEquivalentSalePrice } = getPlanPrices({
        subscriptionPrice,
        monthlyEquivalentPrice,
        discountPercentage: discountedPlan?.discountPercentage,
    });

    return {
        title,
        info,
        currency: studioCatalog?.currency,
        subscriptionPrice: subscriptionPrice,
        monthlyEquivalentPrice: monthlyEquivalentPrice,
        code: planByFrequency?.code,
        salePrice: salePrice,
        monthlyEquivalentSale: monthlyEquivalentSalePrice,
    };
};

export default useStudioPlan;
